import { Component, OnInit, ChangeDetectionStrategy, Input, ComponentFactoryResolver, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { FileUploadContent } from '../../interfaces/file-upload-content.interface';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-shell-file-upload-tile',
    templateUrl: './file-upload-tile.component.html',
    styleUrls: ['./file-upload-tile.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, AsyncPipe]
})
export class FileUploadTileComponent implements OnInit {

  @Input() 
  set item(value: FileUploadContent) {
    this.itemSubject.next(value);
}

@Output() removeItem = new EventEmitter<FileUploadContent>();

  itemSubject: Subject<FileUploadContent> = new BehaviorSubject<FileUploadContent>(undefined);

  constructor() { }

  ngOnInit(): void {
  }

  clickedDeleteButton(event) {
    this.removeItem.emit(event);
  }
}
